// 45be085d06f2b331b038fb65c016444f3a7ecebd|kind=parser-js|name=ResponseMeta|schemaHash=3603b6a5e697ae66f435cb23934c94ab3d5f72e3

import { setDefinedValue } from '@myre/common-primitives';

export function parseResponseMetaFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'rootVersion', _data.rootVersion);
  setDefinedValue(result, 'version', _data.version);
  setDefinedValue(result, 'who', _data.who);

  return {
    ...result,
    ..._data,
  };
}

export function parseResponseMetaToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'rootVersion', _data.rootVersion);
  setDefinedValue(result, 'version', _data.version);
  setDefinedValue(result, 'who', _data.who);

  return {
    ...result,
    ..._data,
  };
}
